import { Link } from 'gatsby';
import { default as React } from 'react';
import { Highlight, Hits, Index } from 'react-instantsearch-dom';
import { v4 as uuidv4 } from 'uuid';

const PageHit = ({ hit }) => (
	<div>
		<Link to={hit.slug}>
			<Highlight attribute="title" hit={hit} tagName="mark" />
		</Link>
	</div>
);

const HitsInIndex = ({ index }) => (
	<Index indexName={index.name}>
		<Hits className="Hits" hitComponent={PageHit} />
	</Index>
);

const SearchResult = ({ indices, className }) => (
	<div className={className}>{indices.map((index) => <HitsInIndex index={index} key={uuidv4()} />)}</div>
);

export default SearchResult;
